<template>
  <svg
    version="1.1"
    id="레이어_4"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 78.8 67.9"
    style="enable-background:new 0 0 78.8 67.9;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M51.8,7.7c-5.6,0-10.1,4.5-10.1,10.1V28c0,0.9,0.8,1.7,1.7,1.7h16.8c0.9,0,1.7-0.7,1.7-1.7V17.8
	C61.9,12.2,57.4,7.7,51.8,7.7C51.8,7.7,51.8,7.7,51.8,7.7z M51.8,11.1c3.7,0,6.6,3,6.6,6.6c0,0,0,0,0,0v8.4H45.1v-8.4
	C45.1,14.1,48.1,11.1,51.8,11.1z"
    />
    <path
      class="st0"
      d="M51.8,37.9c-3.3,0-5.9,2.7-5.9,5.9c0,1.6,0.6,3.1,1.8,4.2v8.3h8.3v-8.3c2.3-2.3,2.4-6,0.1-8.4
	C54.9,38.5,53.4,37.9,51.8,37.9z"
    />
    <path
      class="st0"
      d="M77.1,26.2h-8v-9c0-9.5-7.7-17.3-17.3-17.3c-9.5,0-17.3,7.7-17.3,17.3c0,0,0,0,0,0v9h-8c-0.9,0-1.7,0.7-1.8,1.7
	c0,0,0,0,0,0.1v4.1c-1.5-0.1-3-0.2-4.5-0.2c-10,0-20.2,2.7-20.2,7.9v7l0,0V60l0,0c0,5.3,10.2,8,20.2,8c3.5,0,7-0.3,10.4-1
	c0.4,0.1,0.8,0.1,1.2,0.1h39.9c3.9,0,7.1-3.2,7.1-7.1c0,0,0,0,0,0V28C78.8,27,78.1,26.2,77.1,26.2C77.1,26.2,77.1,26.2,77.1,26.2z
	 M20.2,35.2c2,0,3.9,0.1,5.9,0.3h0.2c7.1,0.8,10.7,3.1,10.7,4.1c0,1.3-5.7,4.5-16.8,4.5S3.4,41.1,3.4,39.8
	C3.4,38.4,9.2,35.3,20.2,35.2L20.2,35.2z M3.5,51.5c3.8,2.2,10.3,3.3,16.7,3.3s13-1.1,16.8-3.3l0,0V53l0,0c0,1.3-5.7,4.5-16.8,4.5
	S3.4,54.3,3.4,53v-1.6L3.5,51.5z M37.1,46.4L37.1,46.4c0,0.4-0.6,1.1-2,1.8c-3.1,1.7-8.8,2.7-14.9,2.7s-11.7-1-14.8-2.7
	c-1.6-0.8-2-1.5-2-1.8v-2c3.8,2.2,10.3,3.3,16.8,3.3s13-1.1,16.8-3.3L37.1,46.4z M3.4,60L3.4,60V58c3.8,2.2,10.3,3.3,16.8,3.3
	s13-1.1,16.8-3.3v2l0,0c0,0.8-2.3,2.4-6.7,3.4h-0.2c-3.3,0.7-6.6,1-9.9,1C9.2,64.5,3.4,61.4,3.4,60z M75.4,60c0,2-1.6,3.6-3.6,3.7
	H38.6c1.2-0.9,1.9-2.2,1.9-3.7V39.8c0-3.8-5.4-6.3-12.3-7.3v-2.8h8c0.9,0,1.7-0.7,1.7-1.7c0,0,0,0,0,0l0,0V17.3
	c0-7.6,6.2-13.8,13.8-13.8c7.6,0,13.8,6.2,13.8,13.8c0,0,0,0,0,0V28l0,0c0,0.9,0.8,1.7,1.7,1.7c0,0,0,0,0,0h8L75.4,60z"
    />
  </svg>
</template>

<script>
export default {
  name: 'StakingIcon',
};
</script>

<style scoped>
.st0 {
  fill: #121212;
}
</style>
